import { Avatar, Button, Card, Checkbox, Divider, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ReactComponent as NoAccountFound } from "../../../../../Assets/noAccounts.svg";
import { translation } from "../../../../../i18n/translationConstant";
import LinkedDelinkedAccountResponse from "../../../../../Models/Response/Account/LinkedDelinkedAccounts";
import { QueryParams, Routes } from "../../../../../Utils/Constants/routes";
import "../index.css";

interface IPendingConsentProps {
  cardClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  selectedCard: string[];
  approvalConsent: (type: string) => void;
  linkedAccounts: LinkedDelinkedAccountResponse;
}

const PendingConsent: React.FC<IPendingConsentProps> = ({
  cardClick,
  selectedCard,
  approvalConsent,
  linkedAccounts,
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  const [linkAccountsToShow, setLinkedAccountsToShow] =
    useState<LinkedDelinkedAccountResponse>([]);

  const [isViewAll, setViewAll] = useState(false);

  useEffect(() => {
    setLinkedAccountsToShow(linkedAccounts.slice(0, 2));
  }, [linkedAccounts]);

  const viewAll = () => {
    if (isViewAll) {
      setLinkedAccountsToShow(linkedAccounts.slice(0, 2));
    } else {
      setLinkedAccountsToShow(linkedAccounts);
    }

    setViewAll(!isViewAll);
  };

  const linkAccountsRedirect = () => {
    history.push({
      pathname: Routes.linkAccounts,
      search: `?${QueryParams.redirect}=${history.location.pathname}`,
    });
  };

  const secondaryButtonClick = () => {
    approvalConsent("FAILED");
  };

  const primaryButtonClick = () => {
    approvalConsent("READY");
  };

  const { Text } = Typography;

  return (
    <div className="pendingConsentContainer">
      {linkAccountsToShow && linkAccountsToShow.length > 0 ? (
        <>
          <div className="consentDetailsAccounts">
            {linkAccountsToShow.map((account, index) => {
              const accountId = index.toString();

              const isSelected =
                selectedCard.indexOf(accountId) !== -1;

              return (
                <Card
                  key={`${account.linkRefNumber || index}`}
                  className={`accountCard ${
                    isSelected ? "accountCardSelected" : ""
                  }`}
                  id={accountId}
                  hoverable={false}
                  onClick={cardClick}
                  role="button"
                  aria-pressed={isSelected}
                >
                  <div className="accountCardInner">
                    <Avatar
                      className="accountCardAvatar"
                      src={account.logoUrl}
                    />

                    <div className="accountInfo">
                      <Text className="accountCardFIP">
                        {account.fipName}
                      </Text>

                      <Text className="accountCardNumber">
                        {account.maskedAccNumber}
                      </Text>

                      <div className="accountCardMeta">
                        <Text className="accountCardAccountType">
                          {account.accountType}
                        </Text>

                        <Divider type="vertical" />

                        <Text className="accountCardAccountType">
                          {account.fiType}
                        </Text>
                      </div>
                    </div>

                    <Checkbox
                      checked={isSelected}
                      className="accountsCardCheckBox"
                      onClick={(event) => event.stopPropagation()}
                    />
                  </div>
                </Card>
              );
            })}
          </div>

          <div className="pendingConsentFooter">
            <div className="pendingConsentViewAll">
              {linkedAccounts.length > 2 ? (
                <Button
                  className="viewAllButton"
                  type="text"
                  onClick={viewAll}
                >
                  {isViewAll ? "View less" : "View all"}
                </Button>
              ) : (
                <span />
              )}
            </div>

            <div className="activeButtonGroup">
              <Button
                className="commonButtonBackground secondaryButton"
                onClick={secondaryButtonClick}
              >
                {t(translation.lblReject)}
              </Button>

              <Button
                disabled={selectedCard.length === 0}
                className="commonButtonBackground primaryButton"
                onClick={primaryButtonClick}
              >
                {t(translation.lblAccept)}
              </Button>
            </div>
          </div>
        </>
      ) : (
        <Card className="noAccountEmpty">
  <div className="noAccountsContent">
    <div className="noAccountImageDiv">
      <NoAccountFound className="noAccountSVG" />
    </div>

    <Typography.Title level={3} className="noAccountTitle">
      We couldn't find any linked accounts
    </Typography.Title>
  </div>

  <div className="noAccountFooter">
    <Button
      className="commonButtonBackground secondaryButton noAccountRejectButton"
      onClick={secondaryButtonClick}
    >
      {t(translation.lblReject)}
    </Button>
  </div>
</Card>
      )}
    </div>
  );
};

export default PendingConsent;